import { render, staticRenderFns } from "./ProposalsListReadonly.vue?vue&type=template&id=7b3fa8e3&scoped=true&"
import script from "./ProposalsListReadonly.vue?vue&type=script&lang=js&"
export * from "./ProposalsListReadonly.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsListReadonly.vue?vue&type=style&index=0&id=7b3fa8e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3fa8e3",
  null
  
)

export default component.exports